export class TreasuryTransactionRequestContractError extends Error {
  constructor() {
    super('Invalid Treasury transaction list request: expected a scalar decimal limit.');
    this.name = 'TreasuryTransactionRequestContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}
export function readTreasuryTransactionsQuery(query = {}) {
  if (query === null || typeof query !== 'object' || Array.isArray(query)) throw new TreasuryTransactionRequestContractError();
  const value = query.limit;
  if (value !== undefined && value !== '' && !(typeof value === 'number' && Number.isFinite(value)
    || typeof value === 'string' && /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/.test(value.trim()) && Number.isFinite(Number(value)))) {
    throw new TreasuryTransactionRequestContractError();
  }
  return query;
}
